import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SurveyFormsView } from "src/components/views/erp/surveys/management/SurveyFormsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/surveys/surveyForms")({
	staticData: { title: i18n.t("survey_forms"), legacyViewKey: "surveyFormManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SurveyFormsView />;
}
